import React, { forwardRef } from "react";
import IconBase, { IconProps } from "./icon-base";

const DataLayerRulesEditor = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <IconBase
      ref={ref}
      renderPath={(color: string) => {
        return (
          <>
            <path
              d="M10.0703 3.19701V0.839707C10.0703 0.37595 10.4462 0 10.9099 0C11.3737 0 11.7496 0.37595 11.7496 0.839707V3.19701C11.7495 3.66066 11.3736 4.03672 10.9099 4.03672C10.4463 4.03672 10.0704 3.66066 10.0703 3.19701Z"
              fill={color}
            />
            <path
              d="M10.0703 17.3401V14.9828C10.0703 14.519 10.4462 14.1431 10.9099 14.1431C11.3737 14.1431 11.7496 14.519 11.7496 14.9828V17.3401C11.7495 17.8037 11.3736 18.1798 10.9099 18.1798C10.4463 18.1798 10.0704 17.8037 10.0703 17.3401Z"
              fill={color}
            />
            <path
              d="M5.01899 8.25L5.10427 8.25437C5.52782 8.29722 5.85862 8.65482 5.85862 9.08971C5.85862 9.52459 5.52782 9.88219 5.10427 9.92504L5.01899 9.92941H2.6619C2.19818 9.92941 1.82227 9.55346 1.82227 9.08971C1.82227 8.62595 2.19818 8.25 2.6619 8.25H5.01899Z"
              fill={color}
            />
            <path
              d="M19.1596 8.25L19.2449 8.25437C19.6684 8.29722 19.9992 8.65482 19.9992 9.08971C19.9992 9.52459 19.6684 9.88219 19.2449 9.92504L19.1596 9.92941H16.8025C16.3388 9.92941 15.9629 9.55346 15.9629 9.08971C15.9629 8.62595 16.3388 8.25 16.8025 8.25H19.1596Z"
              fill={color}
            />
            <path
              d="M16.219 13.2095C16.5469 13.5374 16.5469 14.0701 16.219 14.398C15.8911 14.7259 15.3585 14.7259 15.0306 14.398L16.219 13.2095ZM13.617 11.7957C13.9449 11.4678 14.4764 11.4678 14.8043 11.7957L16.219 13.2095L15.6243 13.8032L15.0306 14.398L13.617 12.9831C13.2891 12.6552 13.2891 12.1237 13.617 11.7957Z"
              fill={color}
            />
            <path
              d="M10.9209 8.25C11.3846 8.25 11.7605 8.62595 11.7605 9.08971C11.7605 9.55346 11.3846 9.92941 10.9209 9.92941H10.9099C10.4462 9.92941 10.0703 9.55346 10.0703 9.08971C10.0703 8.62595 10.4462 8.25 10.9099 8.25H10.9209Z"
              fill={color}
            />
            <path
              d="M15.0306 3.78208C15.3585 3.45415 15.8911 3.45415 16.219 3.78208C16.5465 4.10993 16.5465 4.64162 16.219 4.96948L14.8043 6.3843C14.4765 6.71184 13.9448 6.71184 13.617 6.3843C13.2891 6.05637 13.2891 5.52373 13.617 5.1958L15.0306 3.78208Z"
              fill={color}
            />
            <path
              d="M6.78139 12.0311C7.10931 11.7032 7.64082 11.7032 7.96869 12.0311C8.29647 12.359 8.29646 12.8906 7.96869 13.2185L1.43311 19.7546C1.10518 20.0823 0.573606 20.0814 0.245816 19.7535C-0.0818561 19.4256 -0.082021 18.894 0.245816 18.5661L6.78139 12.0311Z"
              fill={color}
            />
            <path
              d="M8.20533 5.1958C8.5332 5.52373 8.53322 6.05638 8.20533 6.3843C7.87744 6.71221 7.34484 6.71219 7.01694 6.3843L8.20533 5.1958ZM5.60334 3.78208C5.93124 3.45415 6.46274 3.45415 6.79064 3.78208L8.20533 5.1958L7.61059 5.7895L7.01694 6.3843L5.60334 4.96948C5.27545 4.64155 5.27545 4.11 5.60334 3.78208Z"
              fill={color}
            />
          </>
        );
      }}
      {...props}
    >
      {props.children}
    </IconBase>
  );
});

DataLayerRulesEditor.displayName = "DataLayerRulesEditor";

export { DataLayerRulesEditor };
